import * as React from "react";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import { Icon } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import VideoIframe from "../../containers/iframe/VideoIframe";
import "./videoOverlay.css";

const VideoCard = ({ video, onVideoClick }) => (
  <div className="overlay" style={{ paddingLeft: "10px", paddingBottom: "10px" }}>
    <Card sx={{ maxWidth: 280, maxHeight: 350 }}>
      <VideoIframe videourl={video.videourl} />
      <CardHeader
        avatar={
          (
            <Avatar>
              <img src={video.profileurl} alt={video.username} />
            </Avatar>
          )
        }
        action={
          (
            <div onClick={onVideoClick}>
              <IconButton aria-label="settings">
                <Icon>launch</Icon>
              </IconButton>
            </div>
          )
        }
        title={video.username}
        subheader={video.timestamp}
      />
    </Card>
  </div>
);

export default VideoCard;
